import { useEffect, useState } from 'react'

export type PlanCountdownParts = {
  days: number
  hours: number
  minutes: number
  seconds: number
}

const ZERO_COUNTDOWN: PlanCountdownParts = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0
}

function getCountdownParts(targetEpochMs: number | null | undefined): PlanCountdownParts {
  if (typeof targetEpochMs !== 'number') {
    return ZERO_COUNTDOWN
  }

  const remainingMs = targetEpochMs - Date.now()
  if (remainingMs <= 0) {
    return ZERO_COUNTDOWN
  }

  return {
    days: Math.floor(remainingMs / (1000 * 60 * 60 * 24)),
    hours: Math.floor((remainingMs / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((remainingMs / 1000 / 60) % 60),
    seconds: Math.floor((remainingMs / 1000) % 60)
  }
}

/** True when drop time is missing or already past (show 00 + delay card). */
export function isPlanDropDelayed(timeToPlanDrop?: number | null): boolean {
  return typeof timeToPlanDrop !== 'number' || timeToPlanDrop <= Date.now()
}

/** Ticks every second. Stays at 00 when past — no polling for plan roll-out. */
export function usePlanCountdown(timeToPlanDrop: number | null | undefined): PlanCountdownParts {
  const [countdownParts, setCountdownParts] = useState(() => getCountdownParts(timeToPlanDrop))

  useEffect(() => {
    setCountdownParts(getCountdownParts(timeToPlanDrop))

    if (typeof timeToPlanDrop !== 'number') {
      return
    }

    const intervalId = window.setInterval(() => {
      setCountdownParts(getCountdownParts(timeToPlanDrop))
    }, 1000)

    return () => window.clearInterval(intervalId)
  }, [timeToPlanDrop])

  return countdownParts
}
